import api from '../api';

export const get = () => {
  return api.get(`/settings`);
};

export const update = (settings) => {
  return api.put(`/settings`, settings);
};

export const updateUser = (user) => {
  return api.put(`/user`, user);
};
